import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "56929894282";

// Context-aware messages based on current page
const getWhatsAppMessage = (pathname) => {
  switch (pathname) {
    case "/servicios":
      return "Hola, quiero cotizar MP/MC para mi equipo. Equipo: ___, Ciudad: ___.";
    case "/app":
      return "Hola, quiero solicitar acceso a la Odontofix App para mi clínica.";
    case "/contacto":
      return "Hola, quiero agendar evaluación.";
    case "/faq":
      return "Hola, tengo una consulta sobre mantención de equipos.";
    case "/nosotros":
      return "Hola, quiero conocer más sobre los servicios de Odontofix.";
    default:
      return "Hola Odontofix, quiero cotizar mantención y agendar visita.";
  }
};

export const WhatsAppFloat = () => {
  const location = useLocation();
  const message = encodeURIComponent(getWhatsAppMessage(location.pathname));
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all duration-200 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 group"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle className="h-6 w-6 md:h-7 md:w-7 group-hover:animate-pulse" />
      {/* Pulse animation ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25"></span>
    </a>
  );
};
